import { render, staticRenderFns } from "./addUpload.vue?vue&type=template&id=acfa618c&scoped=true&"
import script from "./addUpload.vue?vue&type=script&lang=js&"
export * from "./addUpload.vue?vue&type=script&lang=js&"
import style0 from "./addUpload.vue?vue&type=style&index=0&id=acfa618c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acfa618c",
  null
  
)

export default component.exports